import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

// GraphQLエンドポイントのURLを設定
// 実際のバックエンドのURLに変更してください
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT || '/graphql',
  // Ensure ALL operations are sent as POST
  useGETForQueries: false,
  fetchOptions: { method: 'POST' },
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});

export { client };
